module.exports = __webpack_public_path__ + "static/paris-024.thumb-121297cf9b147bd0a2e32d4689c4d342.jpg";